<template>
  <AppBtn v-if="edit" icon="save" color="positive" type="submit" />
</template>

<script setup>
import AppBtn from "./AppBtn.vue";
import { computed, getCurrentInstance } from "vue";

const instance = getCurrentInstance();
const formParent = p =>
  !p.parent || p.parent.type.__name == "AppEditForm"
    ? p.parent
    : formParent(p.parent);
const editForm = formParent(instance.parent);
const edit = computed(() => editForm?.exposed?.edit.value || true);
</script>